module.exports = __webpack_public_path__ + "static/andi-f6922c77fa288480c59dc1fa5405b972.jpg";